@use '@/styles/tokens' as *;

.body {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
}

.group {
  margin: 0;
  padding: 0;
  border: 0;
}

.legend {
  padding: 0;
  margin-bottom: var(--space-3);
  font-size: 13px;
  font-weight: var(--font-weight-semibold);
  color: var(--text-secondary);
}

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

.chip {
  padding: 6px 14px;
  font-size: 13px;
  color: var(--text-primary);
  background: var(--surface-card);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-pill);
  cursor: pointer;
  transition:
    background 0.12s ease,
    color 0.12s ease,
    border-color 0.12s ease;

  &:hover {
    border-color: var(--border-strong);
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--focus-ring);
  }
}

.active {
  color: var(--text-on-brand);
  background: var(--brand-bg);
  border-color: var(--brand-bg);

  &:hover {
    border-color: var(--brand-bg);
    background: var(--brand-bg-hover);
  }
}
